import React from "react";

// Navigate
import { useNavigate } from "react-router-dom";

// Mui
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Mui Styles
import { StyledButton, StyledPaper } from "@/styles/mui/globalStyles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Components
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { getManningsProducts } from "@/fetch/fetchProduct";
import { createPromotionTarget } from "@/fetch/fetchPromotionTarget";
import { getRegionOptions } from "@/fetch/fetchWork";
import _ from "lodash";
import moment from "moment";

// Redux
import { Select } from "@mui/material";

const PromotionTargetCreatePage = (props) => {
  const { open, setOpen } = props;

  // Navigate and Location and Params
  const navigate = useNavigate();

  //reduxState

  // States
  const [formData, setFormData] = React.useState({
    type: "qty",
    date: moment(),
  });
  const [shopOptions, setShopOptions] = React.useState([]);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [productOptions, setProductOptions] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });
  const setShopTarget = (index, field, value) => {
    const promotion_shop_targets = [...formData.promotion_shop_targets];
    promotion_shop_targets[index][field] = value;
    setFormData({
      ...formData,
      promotion_shop_targets,
    });
  };
  // Submit
  const onClickSubmit = async () => {
    try {
      const { data } = await createPromotionTarget(formData);
      setSnackSeverity("success");
      setSnackMessage("新增成功");
      setSnackOpen(true);
      setTimeout(() => {
        setSnackOpen(false);
        navigate(`/promotionTarget/${data.id}`);
      }, 1000);
    } catch {
      setSnackSeverity("error");
      setSnackMessage("新增失敗");
      setSnackOpen(true);
    }
  };

  const handleAddRow = () => {
    const promotion_shop_targets = formData.promotion_shop_targets
      ? [...formData.promotion_shop_targets]
      : [];
    promotion_shop_targets.push({ shop: [], target_amount: 0 });
    setFormData({
      ...formData,
      promotion_shop_targets,
    });
  };
  const handleRemoveRow = (removeIndex) => {
    const promotion_shop_targets = [...formData.promotion_shop_targets];
    _.remove(
      promotion_shop_targets,
      (promotion_shop_target, index) => index === removeIndex
    );
    setFormData({
      ...formData,
      promotion_shop_targets,
    });
  };
  const fetchAll = async () => {
    const { data: products } = await getManningsProducts(false);
    setProductOptions(products);
    const { data: locations } = await getRegionOptions();
    setShopOptions(locations);
    setSlideTranOn(true);
  };

  React.useEffect(() => {
    fetchAll();
  }, []);

  return (
    <Layout
      header="workLocationManageDetailPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={17}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`新增推廣目標`} history={() => navigate(-1)} />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={theme}>
            <Box validate="true" sx={{ width: 1, flex: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 3,
                    lg: 3,
                  }}
                >
                  <TextField
                    id="name"
                    name="name"
                    label="名稱"
                    value={formData.name}
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 3,
                    lg: 3,
                  }}
                >
                  <DatePicker
                    id="date"
                    name="date"
                    label="日期"
                    value={formData.date}
                    minDate={moment()}
                    onChange={(value) => {
                      setFormData({
                        ...formData,
                        date: moment(value).format("YYYY-MM-DD"),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "100%" }} />
                    )}
                  ></DatePicker>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 3,
                    lg: 3,
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="target-type-label">目標類型</InputLabel>
                    <Select
                      fullWidth
                      labelId="target-type-label"
                      label="目標類型"
                      value={formData.type}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          type: e.target.value,
                        });
                      }}
                    >
                      <MenuItem value={"qty"}>數量</MenuItem>
                      <MenuItem value={"amount"}>銷售數</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 3,
                    lg: 3,
                  }}
                >
                  {formData.type === "qty" && (
                    <ProductAutoComplete
                      multiple
                      fullWidth
                      sx={{ flex: 1 }}
                      productOptions={productOptions}
                      handleOnChange={(value) => {
                        setFormData({
                          ...formData,
                          product_ids: value,
                        });
                      }}
                      selectedValue={formData.product_ids ?? []}
                    ></ProductAutoComplete>
                  )}
                </Grid>

                {/* <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                  }}
                >
                  {formData.promotion_shop_targets?.length > 0 ? (
                    _.map(
                      formData.promotion_shop_targets,
                      (shopTarget, index) => {
                        const selectedShop = [];
                        _.forEach(
                          formData.promotion_shop_targets,
                          (promotion_shop_targets, otherIndex) => {
                            if (otherIndex !== index)
                              selectedShop.push(...promotion_shop_targets.shop);
                          }
                        );
                        return (
                          <TargetRow
                            index={index}
                            setShopTarget={setShopTarget}
                            selectedShop={selectedShop}
                            handleRemoveRow={handleRemoveRow}
                            handleAddRow={handleAddRow}
                            shopTarget={shopTarget}
                            shopOptions={shopOptions}
                            isLastRow={
                              index ===
                              formData.promotion_shop_targets.length - 1
                            }
                          ></TargetRow>
                        );
                      }
                    )
                  ) : (
                    <IconButton color="success" onClick={() => handleAddRow()}>
                      <AddIcon></AddIcon>
                    </IconButton>
                  )}
                </Grid> */}

                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                  }}
                >
                  <Grid justifyContent={"flex-end"} container spacing={2}>
                    <Grid
                      size={{
                        xs: 12,
                        md: 12,
                        lg: 2,
                      }}
                    >
                      <StyledButton
                        variant="contained"
                        size="small"
                        onClick={onClickSubmit}
                      >
                        <Typography variant="subtitle1" noWrap component="div">
                          確認
                        </Typography>
                      </StyledButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </ThemeProvider>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default PromotionTargetCreatePage;
